import React, { Component, Fragment } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import Header from "../Header";
import "react-quill/dist/quill.snow.css";
import Quill from "react-quill";
import { create } from "../../../services/dynamicWPLinks";
import { catList } from "../../../services/course";
import AppContext from "../../../contexts/AppContext";
import { toast } from "react-toastify";

export class DynamicCreate extends Component {
    state = {
        item: {
            parent_nav: "tools",
            page_type: 1,
            page_name: "",
            page_slug: "",
            page_url: "",
            category: "",
            page_seo_title: "",
            meta_description: "",
            featured_image: "",
        },
        errors: {},
        categories: [],
        selectedPageType: "Select",
        selectedParentNav: "Select",
        selectedFile: "",
        resourceTypeList: [],
        fileInput: '',
    };

    onChange = (field) => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;
        let error = this.state.errors;
        error[field.target.name] = null;
        this.setState({ item: temp, errors: error });
    };

    handleQuillChange = (value) => {
        let temp = this.state.item;
        temp.meta_description = value;

        let error = this.state.errors;
        error.meta_description = null;

        this.setState({ item: temp, errors: error });
    };

    getExtension(filename) {
        let parts = filename.split(".");
        return parts[parts.length - 1];
    }

    isImage(filename) {
        let ext = this.getExtension(filename);
        switch (ext.toLowerCase()) {
            case "jpg":
            case "gif":
            case "bmp":
            case "png":
                //etc
                return true;
        }
        return false;
    }

    fileChangedHandler = (event) => {
        const file = event.target.files[0];
        let temp = this.state.item;
        temp.featured_image = URL.createObjectURL(file);
        this.setState({ selectedFile: file, item: temp });
    };

    handlePageTypeSelectChange = (selectedOption) => {
        let temp = this.state.item;
        temp.page_type = selectedOption.value;
        let error = this.state.errors;
        error.page_type = null;
        this.state.selectedPageType = selectedOption.name;
        this.setState({
            item: temp,
            errors: error,
            selectedPageType: selectedOption.name,
        });
    };

    handleParentSelectChange = (selectedOption) => {
        let temp = this.state.item;
        temp.parent_nav = selectedOption.value;
        this.state.selectedParentNav = selectedOption.name;
        let error = this.state.errors;
        error.parent_nav = null;
        this.setState({
            item: temp,
            errors: error,
            selectedParentNav: selectedOption.name,
        });
    };

    handleCategorySelectChange = (selectedOption) => {
        let temp = this.state.item;
        temp.category = selectedOption.value;
        this.state.selectedCategory = selectedOption.name;
        let error = this.state.errors;
        error.category = null;
        this.setState({
            item: temp,
            errors: error,
            selectedCategory: selectedOption.name,
        });
    };

    handleValidation() {
        let fields = this.state.item;
        let errors = {};
        let formIsValid = true;
        let file = this.state.selectedFile;
        let FileSize = file.size / 1024 / 1024; // in MB
        let FileName = file.name;
        let extensionLists = {}; //Create an object for all extension lists
        extensionLists.image = ["jpg", "gif", "bmp", "png"];

        if (!fields.parent_nav) {
            formIsValid = false;
            errors.parent_nav = "The parent nav field is required.";
        }

        if (!fields.page_type) {
            formIsValid = false;
            errors.page_type = "The page type field is required.";
        }

        if (!fields.category) {
            formIsValid = false;
            errors.category = "The category field is required.";
        }

        if (!fields.page_name) {
            formIsValid = false;
            errors.page_name = "The page name field is required.";
        }

        if (!fields.page_slug) {
            formIsValid = false;
            errors.page_slug = "The page slug field is required.";
        }

        if (!fields.page_url) {
            formIsValid = false;
            errors.page_url = "The page url field is required.";
        }

        if (file && FileSize > 2) {
            errors.image = "File size exceeds 2 MB";
        }

        if (file && !this.isImage(FileName)) {
            errors.image = "Please select a valid image file.";
        }

        if (
            fields.page_url &&
            !fields.page_url.match(
                /\(?(?:(http|https|ftp):\/\/)?(?:((?:[^\W\s]|\.|-|[:]{1})+)@{1})?((?:www.)?(?:[^\W\s]|\.|-)+[\.][^\W\s]{2,4}|localhost(?=\/)|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::(\d*))?([\/]?[^\s\?]*[\/]{1})*(?:\/?([^\s\n\?\[\]\{\}\#]*(?:(?=\.)){1}|[^\s\n\?\[\]\{\}\.\#]*)?([\.]{1}[^\s\?\#]*)?)?(?:\?{1}([^\s\n\#\[\]]*))?([\#][^\s\n]*)?\)?/g
            )
        ) {
            formIsValid = false;
            errors.page_url = "Please enter valid page url.";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    removeImage = () => {
        let temp = this.state.item;
        temp.featured_image = '';
        temp.removeImage = true;
        this.state.fileInput.value = '';
        this.setState({ selectedFile: '', item: temp });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        if (this.handleValidation()) {
            let errors = {};
            if (this.state.selectedFile) {
                formData.append(
                    "featured_image",
                    this.state.selectedFile,
                    this.state.selectedFile.name
                );
            }
            formData.append("parent_nav", this.state.item.parent_nav);
            formData.append("page_type", this.state.item.page_type);
            formData.append("category", this.state.item.category);
            formData.append("page_name", this.state.item.page_name);
            formData.append("page_slug", this.state.item.page_slug);
            formData.append("page_url", this.state.item.page_url);
            formData.append("page_seo_title", this.state.item.page_seo_title);
            formData.append(
                "meta_description",
                this.state.item.meta_description
            );
            create(formData)
                .then((response) => {
                    toast.success(response.message);
                    this.props.history.push("/admin/dynamic-wp-links");
                })
                .catch((errors) => {
                    switch (errors.response.status) {
                        case 422:
                            this.setState({
                                errors: errors.response.data.error,
                            });
                            break;
                        case 403:
                            toast.error(errors.response.data.error);
                            break;
                        default:
                            this.context.state.handelError(errors);
                            break;
                    }
                });

            //console.log(formData.values(),this.state.item);
        }
    };

    componentDidMount() {
        catList()
            .then((res) => {
                this.setState({
                    categories: res.data.map((item) => {
                        return { label: item.title, value: item.id };
                    }),
                });
            })
            .catch((error) => {
                this.context.state.handelError(error);
            });
    }

    render() {
        return (
            <Fragment>
                <Header></Header>

                <div className="main-content mt-6">
                    <div className="container mt-3">
                        <div className="row justify-content-center">
                            <div
                                id="formModal"
                                className="col-12 col-lg-10 col-xl-8"
                            >
                                <div className="header">
                                    <div className="header-body">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h6 className="header-pretitle">
                                                    Add Link
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <form
                                    data-select2-id="14"
                                    onSubmit={this.handleSubmit}
                                >
                                    <div className="form-group">
                                        <label htmlFor="parent_nav">
                                            Parent Nav{" "}
                                            <span className="text-danger">
                                                *
                                            </span>
                                        </label>
                                        <Select
                                            defaultValue={{
                                                label: "Tools",
                                                value: "tools",
                                            }}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor: "#1cd2ad",
                                                        boxShadow: "none",
                                                    },
                                                    "&": {
                                                        borderColor: "#d2ddec",
                                                        boxShadow: "none",
                                                    },
                                                }),
                                                dropdownIndicator: (base) => ({
                                                    ...base,
                                                    color: "inherit",
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    color: "inherit",
                                                }),
                                            }}
                                            name="parent_nav"
                                            id="parent_nav"
                                            placeholder="Select"
                                            onChange={
                                                this.handleParentSelectChange
                                            }
                                            options={[
                                                {
                                                    label: "Tools",
                                                    value: "tools",
                                                },
                                                {
                                                    label: "Library",
                                                    value: "library",
                                                },
                                                {
                                                    label: "Resource",
                                                    value: "resource",
                                                },
                                            ]}
                                        ></Select>
                                        {this.state.errors.parent_nav ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.parent_nav}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="category">
                                            Category{" "}
                                            <span className="text-danger">
                                                *
                                            </span>
                                        </label>
                                        <Select
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor: "#1cd2ad",
                                                        boxShadow: "none",
                                                    },
                                                    "&": {
                                                        borderColor: "#d2ddec",
                                                        boxShadow: "none",
                                                    },
                                                }),
                                                dropdownIndicator: (base) => ({
                                                    ...base,
                                                    color: "inherit",
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    color: "inherit",
                                                }),
                                            }}
                                            name="category"
                                            id="category"
                                            placeholder="Select Category"
                                            onChange={
                                                this.handleCategorySelectChange
                                            }
                                            options={this.state.categories}
                                        ></Select>
                                        {this.state.errors.category ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.category}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="page_type">
                                            Page Type{" "}
                                            <span className="text-danger">
                                                *
                                            </span>
                                        </label>
                                        <Select
                                            defaultValue={{
                                                label: "Public",
                                                value: 1,
                                            }}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor: "#1cd2ad",
                                                        boxShadow: "none",
                                                    },
                                                    "&": {
                                                        borderColor: "#d2ddec",
                                                        boxShadow: "none",
                                                    },
                                                }),
                                                dropdownIndicator: (base) => ({
                                                    ...base,
                                                    color: "inherit",
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    color: "inherit",
                                                }),
                                            }}
                                            name="page_type"
                                            id="page_type"
                                            placeholder="Select Page Type"
                                            onChange={
                                                this.handlePageTypeSelectChange
                                            }
                                            options={[
                                                { label: "Public", value: 1 },
                                                {
                                                    label: "Must Be Signed In",
                                                    value: 2,
                                                },
                                                {
                                                    label: "Must Be a Subscriber",
                                                    value: 3,
                                                },
                                            ]}
                                        ></Select>
                                        {this.state.errors.page_type ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.page_type}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="title">
                                            Page Name{" "}
                                            <span className="text-danger">
                                                *
                                            </span>
                                        </label>
                                        <input
                                            id="page_name"
                                            name="page_name"
                                            onChange={this.onChange}
                                            value={
                                                this.state.item.page_name || ""
                                            }
                                            type="text"
                                            className="form-control"
                                        />
                                        {this.state.errors.page_name ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.page_name}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="title">
                                            Page Slug{" "}
                                            <span className="text-danger">
                                                *
                                            </span>
                                            <span
                                                className="text-muted"
                                                style={{ fontSize: "12px" }}
                                            >
                                                (Use to visit the page, i.e.
                                                https://prowriter.co/library/free/[page
                                                slug],
                                                https://prowriter.co/tools/free/[page
                                                slug])
                                            </span>
                                        </label>
                                        <input
                                            id="page_slug"
                                            name="page_slug"
                                            onChange={this.onChange}
                                            value={
                                                this.state.item.page_slug || ""
                                            }
                                            type="text"
                                            className="form-control"
                                            placeholder="https://prowriter.co/library/free/[page slug] or https://prowriter.co/tools/free/[page slug]"
                                        />
                                        {this.state.errors.page_slug ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.page_slug}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="title">
                                            WordPress Page URL{" "}
                                            <span className="text-danger">
                                                *
                                            </span>
                                        </label>
                                        <input
                                            id="page_url"
                                            name="page_url"
                                            onChange={this.onChange}
                                            value={
                                                this.state.item.page_url || ""
                                            }
                                            type="url"
                                            className="form-control"
                                            placeholder="https://www.placeholder.com/"
                                        />
                                        {this.state.errors.page_url ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.page_url}
                                            </div>
                                        ) : null}
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="title">SEO Title</label>
                                        <input
                                            id="page_seo_title"
                                            name="page_seo_title"
                                            onChange={this.onChange}
                                            value={
                                                this.state.item
                                                    .page_seo_title || ""
                                            }
                                            type="text"
                                            className="form-control"
                                        />
                                        {this.state.errors.page_seo_title ? (
                                            <div className="invalid-feedback">
                                                {
                                                    this.state.errors
                                                        .page_seo_title
                                                }
                                            </div>
                                        ) : null}
                                    </div>

                                    <div className="form-group mb-6">
                                        <label
                                            className="mb-1"
                                            htmlFor="meta_description"
                                        >
                                            Meta Description
                                        </label>

                                        <Quill
                                            style={{
                                                height: "200px",
                                            }}
                                            onChange={this.handleQuillChange}
                                            value={
                                                this.state.item
                                                    .meta_description || ""
                                            }
                                        ></Quill>

                                        {this.state.errors.meta_description ? (
                                            <div className="invalid-feedback">
                                                {
                                                    this.state.errors
                                                        .meta_description
                                                }
                                            </div>
                                        ) : null}
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="image">
                                            Featured Image
                                        </label>
                                        <input
                                            id="featured_image"
                                            name="featured_image"
                                            onChange={this.fileChangedHandler}
                                            type="file"
                                            className="form-control"
                                            ref={ref=> this.state.fileInput = ref}
                                        />
                                        {this.state.item
                                                    .featured_image && (
                                                    <div
                                                        style={{
                                                            marginLeft: "auto",
                                                            marginRight: "auto",
                                                            width: "30%",
                                                            position:
                                                                "relative",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                position:
                                                                    "absolute",
                                                                top: "0",
                                                                zIndex: "9999",
                                                            }}
                                                        >
                                                            <a onClick={ this.removeImage } style={{ color: "#000"}}>
                                                                <i class="fa fa-times fa-lg"></i>
                                                            </a>
                                                        </div>
                                                        <img
                                                            src={
                                                                this.state.item
                                                                    .featured_image
                                                            }
                                                            height="200"
                                                            width="200"
                                                        />
                                                    </div>
                                                )}

                                        {this.state.errors.featured_image ? (
                                            <div className="text-danger">
                                                {
                                                    this.state.errors
                                                        .featured_image
                                                }
                                            </div>
                                        ) : null}
                                    </div>

                                    <hr className="mt-5 mb-5" />
                                    <button className="newJob btn btn-block btn-primary text-white">
                                        Add Link
                                    </button>

                                    <div className=" btn-block center-text  mb-6 mt-3 d-flex justify-content-center">
                                        <Link
                                            to={`/admin/dynamic-wp-links`}
                                            className="btn btn-link text-muted"
                                        >
                                            Cancel
                                        </Link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

DynamicCreate.contextType = AppContext;
export default DynamicCreate;



// WEBPACK FOOTER //
// ./src/components/admin/dynamicLinks/DynamicCreate.jsx